'use strict';

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

/**
 * Handles the acceptance of consent tracking by sending an AJAX request to the consent URL.
 * Prevents the default event action, retrieves necessary data attributes, and sends a POST request.
 * On success, stops the spinner. On error, redirects to the provided URL if available.
 *
 * @param {Event} e - The event object.
 */
function acceptConsentTracking(e) {
    e.preventDefault();
    const $consentTrackingContainer = $('.tracking-consent');
    const consentUrl = $consentTrackingContainer.data('accept');
    const tokenName = $consentTrackingContainer.data('tokenname');
    const token = $consentTrackingContainer.data('token');    
    var data = {};
    data[tokenName] = token;
    $.ajax({
        url: consentUrl,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function (response) {
            // Only hide modal if the operation is successful - don't want to give a false impression
            if (response.success) {
                $.spinner().stop();
            }
        },
        error: function (err) {
            // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
}

module.exports = function () {
    if ($('.valid-cookie-warning').length > 0) {
        var previousSessionID = window.localStorage.getItem('previousSid');
        var currentSessionID = getCookie('sid');
        if (!previousSessionID && currentSessionID) {
            // When a user first time visit the home page,
            // set the previousSessionID to currentSessionID
            // and Show the cookie alert
            previousSessionID = currentSessionID;
            window.localStorage.setItem('previousSid', previousSessionID);
            $('.cookie-warning-messaging').show();
        } else if (previousSessionID && previousSessionID === currentSessionID) {
            // Hide the cookie alert if user is in the same session
            $('.cookie-warning-messaging').hide();
        } else {
            // Clear the previousSessionID from localStorage
            // when user session is changed or expired
            window.localStorage.removeItem('previousSid');
        }

        $(document).on('click', '.valid-cookie-warning button',  acceptConsentTracking);
    }
};
